const DEFAULT_DATE_FORMAT = "dd/MM/yyyy";

export { DEFAULT_DATE_FORMAT };
//# sourceMappingURL=constants.js.map
